export default __webpack_public_path__ + "e56875c586bc0de20fbcc4b42eb44d16.png";